import { render } from "./LicenseWarning.vue?vue&type=template&id=d4d47d34"
import script from "./LicenseWarning.vue?vue&type=script&lang=js"
export * from "./LicenseWarning.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"LicenseWarning.vue"]])

export default __exports__